export default "__VITE_ASSET__CKE_9m95__"